var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center row",attrs:{"fluid":""}},[_c('div',{staticClass:"col-12"},[_vm._v("Скоро вы будете перенаправлены на страницу...")]),_c('div',{staticClass:"col-12"},[_c('router-link',{attrs:{"to":_vm.redirectUrl.route}},[_vm._v(" Или нажмите сюда для перехода если это не произошло автоматически ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }